module.exports = __webpack_public_path__ + "media/assets/images/hero-unit/confetti-tablet-d1cd9db3f4c11d99941ccf36e4865da9.png";